
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from "./shared/shared.module";
import { ToastModule, ToastOptions } from 'ng2-toastr/ng2-toastr';
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StoreModule } from '@ngrx/store';

import { AppComponent } from './app.component';
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";
// import { HorizontalLayoutComponent } from "./layouts/horizontal/horizontal-layout.component";

import { CustomOption } from "./shared/toastr/custom-option";

import { AuthService } from './shared/auth/auth.service';
import { AuthGuard } from './shared/auth/auth-guard.service';

import * as $ from 'jquery';

import { DatatransferService } from './dashboard/dashboard2/datatransfer.service';
import { HumidityService } from './forms/elements/input-groups/humidity.service';

// import { CookieService } from 'ngx-cookie-service';
import { SensorsService } from './dashboard/sensors/sensors.service';
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { ProfileService } from './dashboard/profile/profile.service';
import { GasService } from './dashboard/gas/gas.service';
import { GasdetailsService } from './dashboard/gasdetails/gasdetails.service';
import { Co2Service } from './forms/elements/co2/co2.service';
import { Co2detailService } from './forms/elements/co2detail/co2detail.service';
// import { Co2Service } from './dashboard/co2/co2.service';
// import { Co2detailsService } from './dashboard/co2details/co2details.service';

// import { Co2Service } from './dashboard/co2/co2.service';

import { FormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxDateRangePickerModule } from '@kiwigrid/ngx-daterangepicker';
import { BrowserModule } from '@angular/platform-browser';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { WaterService } from './dashboard/water/water.service';
import { WaterdetailsService } from './dashboard/waterdetails/waterdetails.service';

import {DataWorkerModule} from './data-worker/data-worker.module'
import {CookieService} from './data-worker/cookie.service'

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }

@NgModule({
    declarations: [
        AppComponent,
        FullLayoutComponent,
        // HorizontalLayoutComponent,
        ContentLayoutComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        StoreModule.forRoot({}),
        AppRoutingModule,
        SharedModule,
        HttpClientModule,
        ToastModule.forRoot(),
        NgbModule.forRoot(),
        DataWorkerModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
              }
        }),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBr5_picK8YJK7fFR2CPzTVMj6GG1TtRGo'
        }),
        BrowserModule,
        RecaptchaV3Module,
    ],
    providers: [
        DatatransferService,
        //Toastr and auth providers
        { provide: ToastOptions, useClass: CustomOption },
        AuthService,
        AuthGuard,
        SensorsService,
        ProfileService,
        GasService,
        GasdetailsService,
        Co2Service,
        Co2detailService,
        WaterService,
        WaterdetailsService,
        CookieService,
        // // { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Le9vd8ZAAAAALb93cVTtVyohbeoTRdXsIlEwuOL' }
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Ld58ekZAAAAABmZCMPK9DrY3U679GjxUm4FxEkp'}
        // { provide: RECAPTCHA_V3_SITE_KEY, useValue: '' }

    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts